import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sanitizeReservationParams } from '../../shared/helpers';
import { useApi } from '../../shared/providers/api.provider';
import { Reservation } from '../../shared/types';

import { getReservationQueryKey } from './use-get-reservation.hook';

interface CancelReservationParams {
  restaurantId: string;
  reservationId: string;
  secret: string;
}

export const useCancelReservation = ({
  restaurantId,
  reservationId,
  secret,
}: CancelReservationParams) => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<Reservation, Error>({
    mutationFn: async () => {
      const params = sanitizeReservationParams({ restaurantId, reservationId, secret });

      const response = await api.patch<Reservation>(
        `/restaurants/${params.restaurantId}/reservations/${params.reservationId}`,
        { status: 'CANCELLED' },
        {
          params: { secret: params.secret },
        },
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getReservationQueryKey({ restaurantId, reservationId, secret }),
      });
    },
  });
};
